<template>
	<main id="container" class="page-container bg-wave">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="동행뉴스" />
				</div>
			</div>
		</div>
		<div class="page-content news-list">
			<div class="container">
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제 소식을</span> 빠르게 확인하세요.</h3>
				</div>
				<div class="category-filter-buttons">
					<!-- 전체 버튼 -->
					<button 
						type="button" 
						class="btn btn-sm btn-white-outline" 
						:class="{ 'is-active': selectedCategory === '' }" 
						@click="filterNews('')"
					>전체</button>
					<!-- 동적 카테고리 버튼 -->
					<button 
						v-for="category in categories" 
						:key="category.dcd" 
						type="button" 
						class="btn btn-sm btn-white-outline" 
						:class="{ 'is-active': selectedCategory === category.dcd }" 
						@click="filterNews(category.dcd)"
					>{{ category.dcdVal }}</button>
				</div>
				<div class="news-list-content">
					<ul v-if="filteredNewsList.length > 0" class="content-list">
						<li v-for="(item, idx) in filteredNewsList" class="content-list-li" :key="idx">
							<router-link :to="`/ko/news/${item.campnNewsId}`" class="content-list-item">
								<div class="content-list-desc">
									<div class="content-list-desc-img">
										<img :src="item.thmbnlImgPtUrl" :alt="item.campnNewsTit" />
									</div>
									<div class="content-list-desc-text">
										<span class="content-list-desc-title">{{ item.campnNewsTit }}</span>
										<!-- <span class="content-list-desc-date">{{ getTimestampToDateFormat(item.regDt) }}</span> -->
									</div>
								</div>
							</router-link>
						</li>
					</ul>
					<in-ready v-else />
				</div>
			</div>
		</div>
		<div class="pagination-wrap">
			<portal-pagination 
				v-if="isPaging" 
				page-name="NewsList" 
				:page-no="pageNo" 
				:page-size="pageSize" 
				:page-list-size="pageListSize" 
				:total-count="filteredTotalCount" 
				:query="queries" 
				:parent-method-name="pagingMethodName" 
				@getNewsList="getNewsList"
			></portal-pagination>
		</div>
	</main>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACT_GET_NEWS_LIST, ACT_GET_COMMON_CODE_LIST } from '@/store/_act_consts';
import { getItems, lengthCheck, getCheckItems, setPaging, timestampToDateFormat } from '@/assets/js/utils';

import PageHeader from '@/components/content/PageHeader';
import PortalPagination from '@/components/PortalPaginationRoute';
import InReady from '@/components/common/InReady';

export default {
	name: 'NewsList',
	components: { PageHeader, PortalPagination, InReady },
	data: () => ({
		pagingMethodName: 'getNewsList',
		pageNo: 1,
		pageSize: 12,
		pageListSize: 10,
		totalCount: 0,
		filteredTotalCount: 0, // 필터링된 항목 수
		isPaging: false,
		newsList: [], // 전체 뉴스 리스트
		filteredNewsList: [], // 필터링된 뉴스 리스트
		selectedCategory: '', // 선택된 카테고리
		categories: [], // 공통 코드에서 가져온 카테고리 리스트
	}),
	computed: {
		...mapGetters('common', ['isMobile', 'commonCode', 'campn']),
		campnId() {
			return this.campn.campnId;
		},
		queries() {
			const result = {};
			return result;
		},
	},
	created() {
		this.getCategories(); // 공통 코드 가져오기
		this.getNewsList(this.pageNo); // 초기 뉴스 리스트 가져오기
	},
	methods: {
		// 공통 코드에서 카테고리 목록 가져오기
		getCategories() {
			this.$store
				.dispatch(`common/${ACT_GET_COMMON_CODE_LIST}`, {})
				.then((res) => {
					if (lengthCheck(res)) {
						this.categories = getItems(res).filter(item => 
							['1506001', '1506002'].includes(item.dcd) // 행사(1506001), 홍보 마케팅(1506002)
						);
					}
				})
				.catch((e) => {
					console.error("Failed to fetch common codes:", e);
				});
		},
		// 뉴스 리스트 가져오기
		getNewsList(pageNo = 1) {
			this.pageNo = pageNo;
			const params = {
				campnId: this.campnId,
				pageNo: this.pageNo,
				pageSize: this.pageSize,
			};

			this.$store
				.dispatch(`news/${ACT_GET_NEWS_LIST}`, params)
				.then((res) => {
					if (lengthCheck(res)) {
						this.newsList = getCheckItems(res); // 전체 뉴스 리스트 저장
						this.totalCount = res.totalCount || this.newsList.length;
						this.filterNews(this.selectedCategory); // 현재 선택된 카테고리로 필터링
						this.isPaging = this.filteredNewsList.length > 0;
						setPaging(this, res);
					} else {
						this.newsList = [];
						this.filteredNewsList = [];
						this.totalCount = 0;
						this.filteredTotalCount = 0;
						this.isPaging = false;
					}
				})
				.catch((e) => {
					console.error("Error fetching news list:", e);
					this.newsList = [];
					this.filteredNewsList = [];
					this.totalCount = 0;
					this.filteredTotalCount = 0;
					this.isPaging = false;
				});
		},
		getTimestampToDateFormat(timestamp) {
			return timestampToDateFormat(timestamp, "yyyy-MM-dd");
		},
		// 카테고리 필터링 (클라이언트 측)
		filterNews(category) {
			this.selectedCategory = category;
			if (category === '') {
				// "전체" 버튼 클릭 시 모든 뉴스 표시
				this.filteredNewsList = [...this.newsList];
				this.filteredTotalCount = this.totalCount;
			} else {
				// 선택된 카테고리에 따라 필터링
				this.filteredNewsList = this.newsList.filter(item => item.ctgrDcd === category);
				this.filteredTotalCount = this.filteredNewsList.length;
			}
			this.isPaging = this.filteredNewsList.length > 0;
		},
	},
};
</script>

<style scoped>
.category-filter-buttons {
	margin-bottom: 20px;
	display: flex;
	gap: 10px;
}

/* 기본 버튼 스타일 */
.btn-white-outline {
	background-color: #fcfbf9;
	color: rgb(8, 8, 8);
	border: 1px solid #faf9f7;
	border-radius: 15px;
	padding: 5px 10px;
	transition: all 0.3s ease;
}

/* 활성화된 버튼 스타일 */
.btn-white-outline.is-active {
	background-color: #ffae00;
	color: white;
	border-color: #ff9900;
}

/* 비활성화 버튼 호버 시 */
.btn-white-outline:hover:not(.is-active) {
	background-color: #f0f0f0;
}
</style>